export const API_POST_PRESCRIPTION = "API_POST_PRESCRIPTION";
export const API_POST_PRESCRIPTION_SUCCESS = "API_POST_PRESCRIPTION_SUCCESS";
export const API_POST_PRESCRIPTION_FAIL = "API_POST_PRESCRIPTION_FAIL";

export const API_POST_SCAN_PRESCRIPTION = "API_POST_SCAN_PRESCRIPTION";
export const API_POST_SCAN_PRESCRIPTION_SUCCESS = "API_POST_SCAN_PRESCRIPTION_SUCCESS";
export const API_POST_SCAN_PRESCRIPTION_FAIL = "API_POST_SCAN_PRESCRIPTION_FAIL";

export const API_DELETE_SCAN_PRESCRIPTION = "API_DELETE_SCAN_PRESCRIPTION";
export const API_DELETE_SCAN_PRESCRIPTION_SUCCESS = "API_DELETE_SCAN_PRESCRIPTION_SUCCESS";
export const API_DELETE_SCAN_PRESCRIPTION_FAIL = "API_DELETE_SCAN_PRESCRIPTION_FAIL";

export const API_PATCH_PRESCRIPTION = "API_PATCH_PRESCRIPTION";
export const API_PATCH_PRESCRIPTION_SUCCESS = "API_PATCH_PRESCRIPTION_SUCCESS";
export const API_PATCH_PRESCRIPTION_FAIL = "API_PATCH_PRESCRIPTION_FAIL";

export const API_BULK_ANALYSES_PRESCRIPTION = "API_BULK_ANALYSES_PRESCRIPTION";
export const API_BULK_ANALYSES_PRESCRIPTION_SUCCESS = "API_BULK_ANALYSES_PRESCRIPTION_SUCCESS";
export const API_BULK_ANALYSES_PRESCRIPTION_FAIL = "API_BULK_ANALYSES_PRESCRIPTION_FAIL";

export const API_DELETE_PRESCRIPTION = "API_DELETE_PRESCRIPTION";
export const API_DELETE_PRESCRIPTION_SUCCESS = "API_DELETE_PRESCRIPTION_SUCCESS";
export const API_DELETE_PRESCRIPTION_FAIL = "API_DELETE_PRESCRIPTION_FAIL";

export const API_GET_ALL_TO_VALIDATE_PRESCRIPTION = "API_GET_ALL_TO_VALIDATE_PRESCRIPTION";
export const API_GET_ALL_TO_VALIDATE_PRESCRIPTION_SUCCESS = "API_GET_ALL_TO_VALIDATE_PRESCRIPTION_SUCCESS";
export const API_GET_ALL_TO_VALIDATE_PRESCRIPTION_FAIL = "API_GET_ALL_TO_VALIDATE_PRESCRIPTION_FAIL";

export const API_ASSIGN_SECRETARY_PRESCRIPTION = "API_ASSIGN_SECRETARY_PRESCRIPTION";
export const API_ASSIGN_SECRETARY_PRESCRIPTION_SUCCESS = "API_ASSIGN_SECRETARY_PRESCRIPTION_SUCCESS";
export const API_ASSIGN_SECRETARY_PRESCRIPTION_FAIL = "API_ASSIGN_SECRETARY_PRESCRIPTION_FAIL";

export const API_UNASSIGN_SECRETARY_PRESCRIPTION = "API_UNASSIGN_SECRETARY_PRESCRIPTION";
export const API_UNASSIGN_SECRETARY_PRESCRIPTION_SUCCESS = "API_UNASSIGN_SECRETARY_PRESCRIPTION_SUCCESS";
export const API_UNASSIGN_SECRETARY_PRESCRIPTION_FAIL = "API_UNASSIGN_SECRETARY_PRESCRIPTION_FAIL";

export const API_VALIDATE_PRESCRIPTION = "API_VALIDATE_PRESCRIPTION";
export const API_VALIDATE_PRESCRIPTION_SUCCESS = "API_VALIDATE_PRESCRIPTION_SUCCESS";
export const API_VALIDATE_PRESCRIPTION_FAIL = "API_VALIDATE_PRESCRIPTION_FAIL";

export const API_GET_BY_BARCODE_PRESCRIPTION = "API_GET_BY_BARCODE_PRESCRIPTION";

export const API_SET_SAMPLER_PRESCRIPTION = "API_SET_SAMPLER_PRESCRIPTION";
export const API_SET_SAMPLER_PRESCRIPTION_SUCCESS = "API_SET_SAMPLER_PRESCRIPTION_SUCCESS";
export const API_SET_SAMPLER_PRESCRIPTION_FAIL = "API_SET_SAMPLER_PRESCRIPTION_FAIL";

export const API_GET_FPA_PDF = "API_GET_FPA_PDF";
export const API_GET_FPA_PDF_SUCCESS = "API_GET_FPA_PDF_SUCCESS";
export const API_GET_FPA_PDF_FAIL = "API_GET_FPA_PDF_FAIL";

export const API_GET_REPEATABLE_PRESCRIPTION = "API_GET_REPEATABLE_PRESCRIPTION";
export const API_GET_REPEATABLE_PRESCRIPTION_SUCCESS = "API_GET_REPEATABLE_PRESCRIPTION_SUCCESS";
export const API_GET_REPEATABLE_PRESCRIPTION_FAIL = "API_GET_REPEATABLE_PRESCRIPTION_FAIL";

export const API_POST_REPEATABLE_PRESCRIPTION = "API_POST_REPEATABLE_PRESCRIPTION";
export const API_POST_REPEATABLE_PRESCRIPTION_SUCCESS = "API_POST_REPEATABLE_PRESCRIPTION_SUCCESS";
export const API_POST_REPEATABLE_PRESCRIPTION_FAIL = "API_POST_REPEATABLE_PRESCRIPTION_FAIL";

export const API_POST_PRESCRIPTION_SCAN_BARCODE = "API_POST_PRESCRIPTION_SCAN_BARCODE";
export const API_POST_PRESCRIPTION_SCAN_BARCODE_SUCCESS = "API_POST_PRESCRIPTION_SCAN_BARCODE_SUCCESS";
export const API_POST_PRESCRIPTION_SCAN_BARCODE_FAIL = "API_POST_PRESCRIPTION_SCAN_BARCODE_FAIL";

export const API_POST_SAFEPLACE_RESULT_PRESCRIPTION = "API_POST_SAFEPLACE_RESULT_PRESCRIPTION";
export const API_POST_SAFEPLACE_RESULT_PRESCRIPTION_SUCCESS = "API_POST_SAFEPLACE_RESULT_PRESCRIPTION_SUCCESS";
export const API_POST_SAFEPLACE_RESULT_PRESCRIPTION_FAIL = "API_POST_SAFEPLACE_RESULT_PRESCRIPTION_FAIL";

export const API_POST_IATA_DID_PRESCRIPTION = "API_POST_IATA_DID_PRESCRIPTION";
export const API_POST_IATA_DID_PRESCRIPTION_SUCCESS = "API_POST_IATA_DID_PRESCRIPTION_SUCCESS";

export const API_GET_DSP_PRESCRIPTION = "API_GET_DSP_PRESCRIPTION";
export const API_GET_DSP_PRESCRIPTION_SUCCESS = "API_GET_DSP_PRESCRIPTION_SUCCESS";

export const API_PUT_VALID_PRESCRIPTION_SCAN = "API_PUT_VALID_PRESCRIPTION_SCAN";
export const API_PUT_VALID_PRESCRIPTION_SCAN_SUCCESS = "API_PUT_VALID_PRESCRIPTION_SCAN_SUCCESS";
export const API_PUT_VALID_PRESCRIPTION_SCAN_FAIL = "API_PUT_VALID_PRESCRIPTION_SCAN_FAIL";

export const API_PUT_QUALITY_PRESCRIPTION_SCAN = "API_PUT_QUALITY_PRESCRIPTION_SCAN";
export const API_PUT_QUALITY_PRESCRIPTION_SCAN_SUCCESS = "API_PUT_QUALITY_PRESCRIPTION_SCAN_SUCCESS";
export const API_PUT_QUALITY_PRESCRIPTION_SCAN_FAIL = "API_PUT_QUALITY_PRESCRIPTION_SCAN_FAIL";

export const API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN = "API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN";
export const API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN_SUCCESS = "API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN_SUCCESS";
export const API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN_FAIL = "API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN_FAIL";

export const API_GET_SCANS = "API_GET_SCANS";
export const API_GET_SCANS_SUCCESS = "API_GET_SCANS_SUCCESS";
export const API_GET_SCANS_FAIL = "API_GET_SCANS_FAIL";

export const API_GET_ALL_SCANS = "API_GET_ALL_SCANS";
export const API_GET_ALL_SCANS_SUCCESS = "API_GET_ALL_SCANS_SUCCESS";
export const API_GET_ALL_SCANS_FAIL = "API_GET_ALL_SCANS_FAIL";

export const API_PUT_SCAN_ORDO = "API_PUT_SCAN_ORDO";
export const API_PUT_SCAN_ORDO_SUCCESS = "API_PUT_SCAN_ORDO_SUCCESS";
export const API_PUT_SCAN_ORDO_FAIL = "API_PUT_SCAN_ORDO_FAIL";

export const API_DELETE_SCAN_ORDO = "API_DELETE_SCAN_ORDO";
export const API_DELETE_SCAN_ORDO_SUCCESS = "API_DELETE_SCAN_ORDO_SUCCESS";
export const API_DELETE_SCAN_ORDO_FAIL = "API_DELETE_SCAN_ORDO_FAIL";

export const CLEAN_SCANS = "CLEAN_SCANS";
export const CLEAN_MY_SECU_CHECK = "CLEAN_MY_SECU_CHECK";
export const API_GET_MY_SECU_CHECK = "API_GET_MY_SECU_CHECK";
export const API_GET_MY_SECU_CHECK_SUCCESS = "API_GET_MY_SECU_CHECK_SUCCESS";

export const API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC = "API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC";
export const API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC_SUCCESS = "API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC_SUCCESS";

export const API_GET_RELOAD_SCANS = "API_GET_RELOAD_SCANS";
export const API_GET_RELOAD_SCANS_SUCCESS = "API_GET_RELOAD_SCANS_SUCCESS";

export const API_GET_MYLAB_ORDO = "API_GET_MYLAB_ORDO";
export const API_PUT_MOTIVATION = "API_PUT_MOTIVATION";
export const API_PUT_MOTIVATION_SUCCESS = "API_PUT_MOTIVATION_SUCCESS";

export const API_PUT_REFUSED_ANALYSIS = "API_PUT_REFUSED_ANALYSIS";
export const API_PUT_REFUSED_ANALYSIS_SUCCESS = "API_PUT_REFUSED_ANALYSIS_SUCCESS";
export const API_PUT_REFUSED_ANALYSIS_FAIL = "API_PUT_REFUSED_ANALYSIS_FAIL";

export const API_GET_EPN_PDF = "API_GET_EPN_PDF";
export const API_GET_EPN_PDF_SUCCESS = "API_GET_EPN_PDF_SUCCESS";
export const API_GET_EPN_PDF_FAIL = "API_GET_EPN_PDF_FAIL";

export const API_PATCH_DISPENSES_ANALYSES = "API_PATCH_DISPENSES_ANALYSES";

export const API_PATCH_CHECK_ANALYSIS = "API_PATCH_CHECK_ANALYSIS";
export const API_PATCH_CHECK_ANALYSIS_SUCCESS = "API_PATCH_CHECK_ANALYSIS_SUCCESS";
export const API_PATCH_CHECK_ANALYSIS_FAIL = "API_PATCH_CHECK_ANALYSIS_FAIL";

export const API_PATCH_PRESCRIPTION_CONTACT = "API_PATCH_PRESCRIPTION_CONTACT";
export const API_PATCH_PRESCRIPTION_CONTACT_SUCCESS = "API_PATCH_PRESCRIPTION_CONTACT_SUCCESS";
export const API_PATCH_PRESCRIPTION_CONTACT_FAIL = "API_PATCH_PRESCRIPTION_CONTACT_FAIL";
